import { Stack } from '@mui/material';

import { HistoricalDataTabContent } from '@/components/spotter/historicalDataTab/HistoricalDataTabContent';
import { ObservationDetailsPanel } from '@/components/spotter/historicalDataTab/ObservationDetailsPanel';
import { ChartUiContextProvider } from '@/context/ChartUiContext';
import { DateRangeContextProvider } from '@/context/DateRangeContext';
import { TimelineNavigationContextProvider } from '@/context/TimelineNavigationContext';

export const HistoricalDataTabContainer = ({
    noSensorAlerts,
    noCsvDownload,
}: {
    noSensorAlerts?: boolean;
    noCsvDownload?: boolean;
}) => (
    <Stack direction="row" gap={2} alignItems="start">
        <TimelineNavigationContextProvider>
            <DateRangeContextProvider>
                <ChartUiContextProvider>
                    <HistoricalDataTabContent
                        sx={{ flexGrow: 1 }}
                        noSensorAlerts={noSensorAlerts}
                        noCsvDownload={noCsvDownload}
                    />
                    <ObservationDetailsPanel />
                </ChartUiContextProvider>
            </DateRangeContextProvider>
        </TimelineNavigationContextProvider>
    </Stack>
);
